import { TextAreaProps } from './types';
import * as S from './styles';

export const TextArea = ({ numberOfLines, ...props }: TextAreaProps) => (
    <S.TextArea {...{ ...props, numberOfLines: numberOfLines ?? 4 }} type="text" multiline />
);
